export default class CampaignProductQuestionAlternatives {

  constructor() {
      this.id = 0;
      this.description = "";
  }
}